// schema-list/index.ts
export * from "prosemirror-schema-list";
